import { CommandPalette } from "@/components/command-palette";
import { KeyboardShortcutsDialog } from "@/components/keyboard-shortcuts-dialog";
import { Skeleton } from "@/components/ui/skeleton";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Workspace } from "@/components/workspace";
/**
 * App router. Stage 1: the bare tree with the workspace landing and a
 * project detail stub. Later stages lazy-load heavier sections.
 */
import { Suspense, lazy } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";

const ProjectDetailPage = lazy(() => import("@/pages/ProjectDetailPage"));

function RouteFallback(): JSX.Element {
  return (
    <div className="flex h-app-viewport items-center justify-center bg-background">
      <div className="space-y-2 text-center">
        <Skeleton className="mx-auto h-8 w-48" />
        <Skeleton className="mx-auto h-4 w-64" />
      </div>
    </div>
  );
}

export default function App(): JSX.Element {
  return (
    <TooltipProvider delayDuration={150} skipDelayDuration={300}>
      <BrowserRouter>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<Workspace />} />
            <Route path="/project/:projectId/*" element={<ProjectDetailPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
        <CommandPalette />
        <KeyboardShortcutsDialog />
        <Toaster richColors position="bottom-right" />
      </BrowserRouter>
    </TooltipProvider>
  );
}
